import { render } from "./SoundTrack.vue?vue&type=template&id=0b36555c"
import script from "./SoundTrack.vue?vue&type=script&lang=js"
export * from "./SoundTrack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__